export const formatExecutionDate = (dateString) => {
  const date = new Date(dateString);

  const padZero = (num) => (num < 10 ? `0${num}` : num);

  const day = padZero(date.getUTCDate());
  const month = padZero(date.getUTCMonth() + 1); // Meses começam do 0
  const year = date.getUTCFullYear();

  const hours = padZero(date.getUTCHours());
  const minutes = padZero(date.getUTCMinutes());
  const seconds = padZero(date.getUTCSeconds());

  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
};
